<div class="ng-autocomplete w-100">
    <ng-autocomplete 
      #searchInput
      [class]='classSearch'
      [data]="data"
      [searchKeyword]="keyword"
      placeholder='{{placeholderText}}'
      (selected)='selectSearchProduct($event)'
      (inputChanged)='debouncedSearchInput($event)' 
      (inputCleared)='clearedInputSearch()'                              
      (closed)='closedSearchPanel()'                              
      [itemTemplate]="itemTemplate"
      [notFoundTemplate]="notFoundTemplate">                                 
    </ng-autocomplete>
    <ng-template #itemTemplate let-item>
      <a style="padding: 5px 15px;" class="f-s-12 p-10" [innerHTML]="item.description"></a>
        <p style="padding: 0px 15px; font-size: 11px !important; margin-bottom: 5px; margin-top: -4px;">
            {{item.code}}
        </p>
    </ng-template>   
    <ng-template #notFoundTemplate let-notFound>
      <p style="padding-top: 5px;
      margin-bottom: 5px;
      font-weight: 500;" *ngIf="isTypedSearch">No se encontraron registros</p>
    </ng-template>
  </div>

  